import Image, { ImageProps } from 'next/image'
import React from 'react'

import BtcSvg from '@/assets/imgs/bitcoin.svg'
import EthSvg from '@/assets/imgs/ethereum.svg'

type TokenLogoProps = Omit<ImageProps, 'width' | 'height'> & { size: number }

const TokenLogo = ({ size, style, ...restProps }: TokenLogoProps) => {
  return <Image {...restProps} width={size} height={size} style={{ ...style, borderRadius: '50%' }} />
}

type PresetTokenLogoProps = Omit<TokenLogoProps, 'src' | 'alt'>

export const BtcLogo = (props: PresetTokenLogoProps) => {
  return <TokenLogo {...props} src={BtcSvg} alt="Bitcoin" />
}
export const EthLogo = (props: PresetTokenLogoProps) => {
  return <TokenLogo {...props} src={EthSvg} alt="Ethereum" />
}

export default TokenLogo
